exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-modal {\n    z-index: 300; \n    position: fixed;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    text-align: left;\n}\n.custom-modal__inner {\n    margin: 0 auto;\n    border-radius: 5px;\n    width: 80vw;\n    height: 80vh;\n    max-height: 80vh;\n    background-color: #fafafa;\n    top: 10vh;\n    position: relative;\n    overflow: hidden;\n}\n.custom-modal__background {\n    background-color: rgba(0,0,0,.35);\n    position: absolute;\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n    left: 0;\n}\n", ""]);

// exports
